/**
 * "Vale solo l'ultima richiesta": quando i filtri cambiano due volte di fila, la risposta della prima
 * richiesta puo' arrivare DOPO quella della seconda e rimettere a video i numeri vecchi
 * (difetto "aggiorno i filtri e la dashboard non si aggiorna", 26/10/2026).
 *
 * Uso negli store: `const t = gate.begin();` all'inizio del caricamento, poi ogni scrittura
 * dei risultati passa da `if (gate.isCurrent(t))` (o da `gate.guard(t, set)`).
 * Testato in __tests__/requestGate.test.ts e __tests__/staleResponses.test.ts.
 */
export interface RequestGate {
  /** Apre una nuova richiesta: da qui le precedenti sono superate. */
  begin: () => number;
  /** La richiesta `token` e' ancora l'ultima aperta? */
  isCurrent: (token: number) => boolean;
  /** Restituisce `set` che scrive solo finche' `token` e' l'ultima richiesta. */
  guard: <A extends unknown[]>(token: number, set: (...args: A) => void) => (...args: A) => void;
}

export function createRequestGate(): RequestGate {
  let last = 0;
  return {
    begin: () => ++last,
    isCurrent: (token) => token === last,
    guard: (token, set) => (...args) => { if (token === last) set(...args); },
  };
}
